module.exports = "/assets/data/1e3baf8b5fd404a2135e409f17761b2b-B28.data.json";